// extracted by mini-css-extract-plugin
module.exports = {"widgetCard":"styles_widgetCard__DM5Jv","title":"styles_title__1RqLB"};